module.exports = __webpack_public_path__ + "static/media/no-image.1e6cef7b.svg";